import React from 'react';

const iconRobot = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_6275_3692"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="100"
      height="100"
    >
      <circle cx="50" cy="50" r="50" fill="white" />
    </mask>
    <g mask="url(#mask0_6275_3692)">
      <rect
        x="-21.7285"
        y="-1.04395"
        width="138.462"
        height="176.044"
        fill="#27385A"
      />
      <g clipPath="url(#clip0_6275_3692)">
        <path
          d="M61.7924 70.0964C61.7924 72.0437 57.3513 73.5834 51.8679 73.5834C46.3845 73.5834 41.9434 71.9984 41.9434 70.0964C41.9434 68.1944 46.3845 66.6094 51.8679 66.6094C57.3513 66.6094 61.7924 68.1491 61.7924 70.0964Z"
          fill="#83BB26"
        />
        <path
          d="M61.7924 74.3991C61.7924 76.3464 57.3513 77.8861 51.8679 77.8861C46.3845 77.8861 41.9434 76.3011 41.9434 74.3991C41.9434 72.4971 46.3845 70.9121 51.8679 70.9121C57.3513 70.8668 61.7924 72.4518 61.7924 74.3991Z"
          fill="#83BB26"
        />
        <path
          d="M76.7934 119.005C76.9747 120.228 75.8871 121.451 74.301 121.632C59.3915 123.579 44.4821 123.579 29.5727 121.632C27.9866 121.405 26.899 120.228 27.0803 119.005C29.2555 105.057 29.2555 91.1091 27.0803 77.2062C26.899 75.9835 27.9866 74.7608 29.5727 74.5796C44.4821 72.6323 59.3915 72.6323 74.301 74.5796C75.8871 74.806 76.9747 75.9835 76.7934 77.2062C74.5729 91.1091 74.5729 105.057 76.7934 119.005Z"
          fill="#F7A600"
        />
        <path
          d="M102.485 135.268L98.6782 134.271C102.394 120.097 99.7658 106.375 90.8383 93.5138C84.086 83.7773 76.1102 78.2071 76.0195 78.1618L78.2401 74.9012C78.6026 75.1276 86.8504 80.8789 94.0105 91.1589C103.527 104.881 106.473 120.142 102.485 135.268Z"
          fill="#83BB26"
        />
        <path
          d="M85.0866 74.9917C86.0836 78.524 83.999 82.1469 80.5095 83.1432C76.9748 84.1395 73.3494 82.0564 72.3524 78.5693C71.3554 75.037 73.3947 71.3688 76.9295 70.4178C80.4189 69.4215 84.0896 71.4594 85.0866 74.9917Z"
          fill="#1DBADF"
        />
        <path
          d="M101.673 99.627C102.443 102.344 100.857 105.152 98.1383 105.922C95.4192 106.692 92.6095 105.107 91.8391 102.389C91.0687 99.6723 92.6549 96.8192 95.3739 96.0946C98.0929 95.3248 100.903 96.9098 101.673 99.627Z"
          fill="#1DBADF"
        />
        <path
          d="M0.342285 137.392L4.14894 136.396C0.43292 122.221 3.06133 108.499 11.9888 95.638C18.7411 85.9015 26.717 80.3313 26.8076 80.286L24.5871 77.0254C24.2245 77.2518 15.9768 83.0032 8.81663 93.2831C-0.700014 106.96 -3.64564 122.221 0.342285 137.392Z"
          fill="#83BB26"
        />
        <path
          d="M17.7456 77.0707C16.7486 80.603 18.8332 84.2259 22.3227 85.2222C25.8574 86.2185 29.4828 84.1353 30.4798 80.6483C31.4768 77.116 29.4375 73.4478 25.9027 72.4968C22.4133 71.5005 18.7426 73.5384 17.7456 77.0707Z"
          fill="#1DBADF"
        />
        <path
          d="M1.15555 101.706C0.385154 104.423 1.97126 107.231 4.6903 108.001C7.40934 108.771 10.219 107.186 10.9894 104.469C11.7598 101.752 10.1737 98.8985 7.45466 98.174C4.73562 97.4041 1.92594 98.9891 1.15555 101.706Z"
          fill="#1DBADF"
        />
        <path
          d="M60.1635 84.2715C56.81 84.2715 53.9097 86.1735 52.4596 88.936C51.0094 86.1735 48.1091 84.2715 44.7556 84.2715C39.952 84.2715 36.0547 88.1661 36.0547 92.9664C36.0547 104.333 52.4596 113.39 52.4596 113.39C52.4596 113.39 54.8614 112.077 57.8523 109.813C59.9823 108.183 62.3841 106.099 64.378 103.654C66.9611 100.574 68.9098 96.9063 68.9098 93.0117C68.8645 88.1661 64.9672 84.2715 60.1635 84.2715Z"
          fill="#FF2180"
        />
        <path
          d="M49.7422 37.4906C50.6939 35.2263 51.7815 33.0978 52.8238 31.0147C55.0443 26.6672 57.0836 22.5915 57.8087 17.6553L59.4401 17.8817C58.715 23.0896 56.5851 27.3012 54.3192 31.7393C53.2769 33.7771 52.1893 35.9056 51.283 38.1246L49.7422 37.4906Z"
          fill="#4C291B"
        />
        <path
          d="M43.5768 34.7282C42.2173 32.6904 40.7218 30.7883 39.317 28.9316C36.2807 25.1276 33.471 21.5047 31.8396 16.7949L30.2988 17.3384C32.0209 22.2745 34.9212 26.0333 38.0028 29.9732C39.4076 31.7846 40.8578 33.6414 42.2173 35.634L43.5768 34.7282Z"
          fill="#4C291B"
        />
        <path
          d="M18.5624 54.1103C18.9703 58.3672 20.6924 61.6731 22.4144 61.4919C24.1365 61.3108 25.1788 57.7784 24.7709 53.5216C24.3631 49.2647 22.641 45.9588 20.9189 46.1399C19.2422 46.2758 18.1546 49.8534 18.5624 54.1103Z"
          fill="#83BB26"
        />
        <path
          d="M75.8437 48.5859C76.2515 52.8428 77.9736 56.1486 79.6957 55.9675C81.4177 55.7864 82.46 52.254 82.0522 47.9971C81.6443 43.7402 79.9223 40.4344 78.2002 40.6155C76.5235 40.7966 75.4358 44.3742 75.8437 48.5859Z"
          fill="#83BB26"
        />
        <path
          d="M78.3773 40.3888L75.341 40.6605C70.2201 34.6375 59.9784 31.0599 48.5584 32.1467C37.1385 33.2789 27.7578 38.7132 23.8605 45.642L20.8242 45.9137L22.365 61.6733L25.4013 61.4016C30.5221 67.4246 40.7639 71.0022 52.1838 69.9154C63.6038 68.8285 72.9845 63.3942 76.8365 56.4654L79.8727 56.1937L78.3773 40.3888Z"
          fill="#F7A600"
        />
        <path
          d="M41.9403 53.1547C45.9999 53.1547 49.2908 49.866 49.2908 45.8093C49.2908 41.7525 45.9999 38.4639 41.9403 38.4639C37.8808 38.4639 34.5898 41.7525 34.5898 45.8093C34.5898 49.866 37.8808 53.1547 41.9403 53.1547Z"
          fill="white"
        />
        <path
          d="M57.6602 48.785C60.521 48.785 62.84 46.4676 62.84 43.6088C62.84 40.7501 60.521 38.4326 57.6602 38.4326C54.7995 38.4326 52.4805 40.7501 52.4805 43.6088C52.4805 46.4676 54.7995 48.785 57.6602 48.785Z"
          fill="white"
        />
        <path
          d="M42.5699 49.9985C45.1628 49.9985 47.2648 47.898 47.2648 45.3069C47.2648 42.7158 45.1628 40.6152 42.5699 40.6152C39.977 40.6152 37.875 42.7158 37.875 45.3069C37.875 47.898 39.977 49.9985 42.5699 49.9985Z"
          fill="#83BB26"
        />
        <path
          d="M57.5049 46.9553C59.3845 46.9553 60.9082 45.4326 60.9082 43.5543C60.9082 41.676 59.3845 40.1533 57.5049 40.1533C55.6253 40.1533 54.1016 41.676 54.1016 43.5543C54.1016 45.4326 55.6253 46.9553 57.5049 46.9553Z"
          fill="#83BB26"
        />
        <path
          d="M44.4347 49.6277C41.9876 50.624 39.2232 49.5371 38.2262 47.1369C37.2292 44.7368 38.4075 41.9743 40.8093 40.978C43.2111 39.9817 46.0208 41.0686 47.0178 43.4688C48.0148 45.8689 46.8818 48.6314 44.4347 49.6277Z"
          fill="#83BB26"
        />
        <path
          d="M54.2257 42.6982C53.8632 44.4644 55.0414 46.2306 56.8541 46.5928C58.6668 46.9551 60.4795 45.823 60.842 44.0568C61.2046 42.2907 60.0263 40.5245 58.2136 40.1622C56.4009 39.7999 54.5882 40.9321 54.2257 42.6982Z"
          fill="#83BB26"
        />
        <path
          d="M42.675 48.0286C44.2818 48.0286 45.5844 46.7269 45.5844 45.1212C45.5844 43.5155 44.2818 42.2139 42.675 42.2139C41.0682 42.2139 39.7656 43.5155 39.7656 45.1212C39.7656 46.7269 41.0682 48.0286 42.675 48.0286Z"
          fill="#1D1D1B"
        />
        <path
          d="M57.4919 45.4976C58.6633 45.4976 59.6128 44.5487 59.6128 43.3782C59.6128 42.2077 58.6633 41.2588 57.4919 41.2588C56.3206 41.2588 55.3711 42.2077 55.3711 43.3782C55.3711 44.5487 56.3206 45.4976 57.4919 45.4976Z"
          fill="#1D1D1B"
        />
        <path
          d="M42.4891 47.1819C42.3984 47.7706 41.8546 48.1329 41.2655 48.0423C40.6764 47.9517 40.3138 47.4083 40.4045 46.8196C40.4951 46.2309 41.0389 45.8686 41.628 45.9591C42.1718 46.095 42.5797 46.6384 42.4891 47.1819Z"
          fill="white"
        />
        <path
          d="M57.8962 44.7817C58.0321 45.1893 58.4853 45.3705 58.8479 45.2346C59.2557 45.0988 59.437 44.6459 59.301 44.2836C59.1651 43.876 58.7119 43.6949 58.3494 43.8307C57.9415 43.9666 57.7602 44.3742 57.8962 44.7817Z"
          fill="white"
        />
        <path
          d="M28.8508 24.0408C25.4973 23.2257 23.5033 19.8292 24.319 16.5233C25.1348 13.1721 28.5336 11.1795 31.8417 11.9947C35.1952 12.8098 37.1892 16.2063 36.3735 19.5122C35.5577 22.8181 32.2043 24.856 28.8508 24.0408Z"
          fill="#83BB26"
        />
        <path
          d="M30.2508 15.6174C30.2508 14.6663 29.4804 13.8965 28.5287 13.8965C27.577 13.8965 26.8066 14.6663 26.8066 15.6174C26.8066 16.5684 27.577 17.3382 28.5287 17.3382C29.4804 17.3382 30.2508 16.6137 30.2508 15.6174Z"
          fill="white"
        />
        <path
          d="M60.4783 22.7278C63.0614 22.0938 64.6022 19.4672 63.9677 16.9312C63.3333 14.3499 60.7049 12.8102 58.1671 13.4442C55.584 14.0782 54.0432 16.7048 54.6777 19.2408C55.3121 21.8221 57.8952 23.3618 60.4783 22.7278Z"
          fill="#83BB26"
        />
        <path
          d="M59.3906 16.2512C59.3906 15.5266 59.9798 14.8926 60.7501 14.8926C61.4752 14.8926 62.1097 15.4813 62.1097 16.2512C62.1097 17.021 61.5205 17.6097 60.7501 17.6097C59.9798 17.6097 59.3906 17.021 59.3906 16.2512Z"
          fill="white"
        />
        <path
          d="M42.6211 56.7375C43.3009 60.451 48.0139 62.7606 53.18 61.8549C58.3462 60.9491 62.0169 57.1904 61.3825 53.4316"
          stroke="#FF2180"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6275_3692">
        <rect
          width="110.769"
          height="141.429"
          fill="white"
          transform="translate(-3.92578 11.8135)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default iconRobot;
